var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0811 8.1532C14.0953 6.7688 13.6986 5.41129 12.9413 4.25233C12.184 3.09336 11.1 2.185 9.82639 1.64211C8.5528 1.09922 7.14682 0.946189 5.78626 1.20236C4.4257 1.45853 3.17166 2.1124 2.18271 3.08129C1.19377 4.05018 0.514338 5.29056 0.230345 6.64559C-0.0536482 8.00062 0.0705507 9.40943 0.587232 10.6939C1.10391 11.9783 1.98987 13.0807 3.13308 13.8616C4.27628 14.6425 5.62538 15.0669 7.00978 15.0811C8.86514 15.0966 10.651 14.3762 11.9764 13.0777C13.3017 11.7792 14.0586 10.0085 14.0811 8.1532Z",
    fill: "#0091EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 8.51562H7.90625V11.7344H6.34375V8.51562H3.5V7.03125H6.34375V3.79688H7.90625V7.03125H10.7812V8.51562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusButton);
export default __webpack_public_path__ + "static/media/plus_button.c807e0804d356c9ff20c6f2502e8420e.svg";
export { ForwardRef as ReactComponent };